<template>
    <Breadcrumbs main="Ui Kits" title="Grid" />
    <div class="container-fluid grid-wrrapper">
        <div class="row">
            <gridOptions />
            <gridColumm />
            <gridAlignment />
            <gridSection />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const gridOptions = defineAsyncComponent(() => import("@/components/theme/uikits/grid/gridOptions.vue"))
const gridColumm = defineAsyncComponent(() => import("@/components/theme/uikits/grid/gridColumm.vue"))
const gridAlignment = defineAsyncComponent(() => import("@/components/theme/uikits/grid/gridAlignment.vue"))
const gridSection = defineAsyncComponent(() => import("@/components/theme/uikits/grid/gridSection.vue"))
</script>